import React, {useState, useEffect, forwardRef} from 'react';
import {Loader, Select, Text} from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../../../store';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// eslint-disable-next-line react/display-name
const UserItem = forwardRef(
  ({ displayName, email, jobTitle, department, ...others }, ref) => {
    return (
      <div style={{ padding: '8px' }} ref={ref} {...others}>
        <Text fw='bold'>{displayName}</Text>
        <Text size='sm'>{email}</Text>
        <Text size='sm'>{jobTitle}</Text>
        <Text size='sm'>{department}</Text>
      </div>
    )});

export const UserDropdown = ({ initialValue, suggestAction }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.suggestUsers.isLoading);
  const userSuggestions = useSelector((state) => state.user.suggestUsers.data);
  
  const [selectedUser, setSelectedUser] = useState(initialValue);
  const [suggestQuery, setSuggestQuery] = useState(null);
  
  useEffect(() => {
    if (initialValue?.id) {
      setSelectedUser(initialValue);
      dispatch(suggestAction(null, initialValue.id));
    }
  }, [initialValue?.id]);

  useEffect(() => {
    if (suggestQuery) {
      dispatch(suggestAction(suggestQuery, initialValue?.id));
    }
  }, [suggestQuery]);

  useEffect(() => {
    dispatch(userActions.updateActiveUser(selectedUser?.id));
  }, [selectedUser]);

  const suggestUsers = _.debounce((query) => {
    if (query.length > 0) {
      setSuggestQuery(query);
    }
  }, 1000);

  return (
    <Select
      searchable
      hoverOnSearchChange
      onSearchChange={suggestUsers}
      value={selectedUser?.id}
      nothingFound="No options"
      data={userSuggestions}
      onChange={(value) => { setSelectedUser(userSuggestions.find((u) => u.id === value)); }}
      filter={() => true}
      itemComponent={UserItem}
      rightSection={isLoading ? <Loader size='xs' /> : <FontAwesomeIcon icon="search" />}
    />
  );
};
